import React, { useEffect, useState } from "react"
// Utilities
import { isObjectEmpty } from "../../utilities/checkValidity"
// Components
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader"
import ProductBoxContainer from "./ProductBoxContainer"

const ProductBoxSection = ({
  title,
  type,
  productData,
  shopifyData,
  handleOpenQuickBuyModal,
  handleProduct,
  handleShopify,
  modifierClass = "",
  handleSelectedProductColor,
  aboveTheFold = false,
}) => {
  const [isSkeletonLoader, setIsSkeletonLoader] = useState(true)

  const [filteredProductData, setFilteredProductData] = useState({})
  const [filteredShopifyData, setFilteredShopifyData] = useState([])
  const [combinedFilteredData, setCombinedFilteredData] = useState([])

  useEffect(() => {
    setTimeout(() => {
      setIsSkeletonLoader(false)
    }, 300)

    // Set the filtered product data according to type and if the product is visible
    let filteredData = []
    Object.keys(productData).map(productId => {
      if (productData[productId].type === type && !productData[productId].hidden) {
        filteredData = [...filteredData, [productId, productData[productId]]]
      }
    })
    setFilteredProductData(Object.fromEntries(filteredData))
  }, [])

  // Set the filtered shopify data by the filtered product
  useEffect(() => {
    if (isObjectEmpty(filteredProductData)) return

    let filteredData = []

    Object.keys(filteredProductData).forEach(productId => {
      let shopifyProduct = []

      shopifyProduct = shopifyData.filter(item => item.shopifyId === productId)

      if (shopifyProduct.length) {
        if (!filteredData.some(product => product === shopifyProduct[0].shopifyId)) {
          filteredData = [...filteredData, shopifyProduct[0]]
        }
      }
    })
    setFilteredShopifyData(filteredData)
  }, [filteredProductData])

  useEffect(() => {
    if (!filteredShopifyData.length) return

    let combinedData = []

    filteredShopifyData.forEach(shopifyProduct => {
      Object.keys(filteredProductData).map(productId => {
        if (productId === shopifyProduct.shopifyId) {
          const product = [
            {
              shopifyData: shopifyProduct,
              productData: filteredProductData[productId],
            },
          ]

          combinedData = [...combinedData, ...product]
        }
      })
    })
    setCombinedFilteredData(combinedData)
  }, [filteredShopifyData])

  return (
    <section className={`pb--30 ${modifierClass}`} style={{ minHeight: "800px" }}>
      <div
        className={`container ${
          type === "merchandise" || type === "supplements" || type === "meal plan" ? "container--xxxl" : ""
        }`}
      >
        <h2 className="h2--sm txt--uppercase mb--40">
          shop <span className="txt--pink">{title}</span>
        </h2>

        {isSkeletonLoader ? (
          <div className="row justify-content-center">
            <SkeletonLoader data={filteredProductData} type={type} />
          </div>
        ) : (
          <div className="row justify-content-center">
            {combinedFilteredData.map((combinedProduct, index) => (
              <ProductBoxContainer
                key={`${combinedProduct.shopifyId}-${index}`}
                data={combinedProduct}
                type={type}
                handleOpenQuickBuyModal={handleOpenQuickBuyModal}
                handleProduct={handleProduct}
                handleShopify={handleShopify}
                imgOrientation={type === "apparel" || type === "merchandise" ? "vertical" : ""}
                handleSelectedProductColor={handleSelectedProductColor ? handleSelectedProductColor : () => {}}
                aboveTheFold={aboveTheFold}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
export default ProductBoxSection
